// @ts-nocheck

import factoriesGql from './factories/graphql';
import factoriesRest from './factories/rest';

type restFactories = keyof typeof factoriesRest;
type gqlFactories = keyof typeof factoriesGql;

interface IRestFactory {
  get<T>(factory: restFactories): T;
  list<T>(factory: restFactories, count: number): T[];
}

interface IGqlFactory {
  get<T>(operation: gqlFactories): { data: { [operation]: T } };
  list<T>(
    operation: gqlFactories,
    count: number,
  ): { data: { [operation]: T[] } };
}

class RestFactory implements IRestFactory {
  get<T>(factory: restFactories): T {
    return factoriesRest[factory]() as T;
  }

  list<T>(factory: restFactories, count: number): T[] {
    const list = [] as T[];

    for (let index = 0; index < count; index++) {
      list.push(this.get(factory));
    }

    return list;
  }
}

class GqlFactory implements IGqlFactory {
  create<T>(operation: gqlFactories): T {
    return factoriesGql[operation]() as T;
  }

  get<T>(operation: gqlFactories): { data: { [operation]: T } } {
    return {
      data: this.create<T>(operation),
    };
  }

  list<T>(
    operation: gqlFactories,
    count: number,
  ): { data: { [operation]: T[] } } {
    const list = [] as T[];

    for (let index = 0; index < count; index++) {
      list.push(this.create<T>(operation));
    }

    return {
      data: {
        [operation]: list,
      },
    };
  }
}

interface IMockBuilder {
  rest(): RestFactory;
  graphql(): GqlFactory;
}

export default class MockBuilder implements IMockBuilder {
  rest(): RestFactory {
    return new RestFactory();
  }

  graphql(): GqlFactory {
    return new GqlFactory();
  }
}
